import {Timestamp} from 'firebase/firestore';
import {z} from 'zod';

export const FIRESTORE_TIMESTAMP_SCHEMA = z.instanceof(Timestamp).describe(
    'Firestore Timestamp'
);
